import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const Container = styled.div`
  margin-top: 28px;
`;
export const ModalStyle = styled(Modal)`
  .modal-content {
    padding: 26px;
    border-radius: 10px;
    max-width: 500px;
    width: 100%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  span {
    color: #808495;
    font-size: 1.125rem;
  }
  svg {
    cursor: pointer;
    color: #074f8c;
  }

`;


export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 22px;
  svg {
    margin-right: 16px;
  }

  p {
    width: 100%;
    margin: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
  

`;
